
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { HoundModel } from '../../../common';
import { ChevronRight, Plus as PlusIcon, Wallet as WalletIcon } from '@vicons/fa';
import breakpoints from '../utils/breakpoints';

export default defineComponent({
  name: 'LeaderboardListItem',
  props: {
    hound: {
      type: Object,
      default: {},
      required: true
    },
    index: {
      type: Number
    }
  },
  components: {
    ChevronRight,
    PlusIcon,
    WalletIcon
  },
  setup (props) {
    const router = useRouter();
    const openHound = (id: string) => {
      const targetRoute = router.resolve({
        name: 'Hound',
        params: {
          id: id
        }
      }).fullPath;
      const basePath = window.location.origin;
      window.open(basePath + targetRoute);
    };
    const hound = props.hound as HoundModel;

    return {
      openHound,
      hound,
      breakpoints,
      index: props.index
    };
  }
});
